import axios from "axios";
import { getSessionToken } from "../../utils/Auth/AuthUtils";

const API_URL = "/api/gender";

// Get Gender
const getGender = async () => {
  const token = await getSessionToken();
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  const response = await axios.get(
    API_URL  , 
    config
  );
  return response.data;
};

//Edit gender
const editGender = async (genderData) => {
  const token = await getSessionToken();

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  const response = await axios.post(API_URL + "/update", genderData, config);

  return response.data;
};



const schoolService = {
  editGender,
  getGender,
};

export default schoolService;
